import gql from 'graphql-tag';

import fileFragment from '~/shared/graphql-queries/files/file-fragment';
import { homeTaskFragment } from '~/shared/graphql-queries/home-tasks';
import { lessonExerciseFragment } from '~/shared/graphql-queries/lesson-exercises';

export default gql`
  fragment LessonFragment on Lesson {
    _id
    id
    title
    status
    alias
    videoCallStatus
    creator {
      _id
    }
    attachments {
      ...FileFragment
    }
    notesAboutStudent
    studentMark
    notes
    image {
      path
    }
    thumbnail {
      path
    }
    videos {
      ...FileFragment
    }
    files {
      ...FileFragment
    }
    studentSurvey {
      field
      value
    }
    vote {
      isVoted
      voteRate
    }
    workOnHomeTask {
      notes
    }
    data {
      student
      course
      isZeroLesson
      courseCategory
      homeTaskStatus
      lessonTemplate
      originalLesson
      isLessonChanged
      filesOfExercises {
        _id
        exerciseId
        fileId
        status
        files {
          _id
          id
          status
        }
      }
    }
    lessonExercises {
      ...LessonExerciseFragment
    }
    homeTask {
      ...HomeTaskFragment
    }
  }
  ${lessonExerciseFragment}
  ${homeTaskFragment}
`;

export const lightLessonFragment = gql`
  fragment LightLessonFragment on Lesson {
    _id
    id
    title
    status
    alias
    videoCallStatus
    creator {
      _id
    }
    notesAboutStudent
    studentMark
    notes
    image {
      path
    }
    thumbnail {
      path
    }
    files {
      ...FileFragment
    }
    attachments {
      ...FileFragment
    }
    videos {
      ...FileFragment
    }
    workOnHomeTask {
      notes
    }
    data {
      student
      course
      isZeroLesson
      courseCategory
      homeTaskStatus
      lessonTemplate
      originalLesson
      isLessonChanged
      filesOfExercises {
        _id
        exerciseId
        fileId
        status
        files {
          _id
          id
          status
        }
      }
    }
    homeTask {
      _id
      title
      notes
      data {
        courseCategory
        course
      }
    }
    lessonExercises {
      _id
      title
      notes
      data {
        course
        courseCategory
        student
        isShared
        isTodo
        standaloneFile
      }
    }
  }
  ${fileFragment}
`;

